var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import PurBackService from "../../api/PurBackService";
import CommonService from '../../api/CommonService';
import { summaries, toDetail } from "../../helper/util";
import { EBillType } from "../../enum/EBillType";
import GlobalVue from "../../globalVue";
import { EPurInStatus } from "../../enum/EStatus";
import { auth } from "../../helper/authDecorator";
import { nameDict } from "../../constant/authCode";
import { mapGetters } from "vuex";
import ArtMsglist from '../../components/alert/ArtMsglist.vue';
import ImageView from "../purchasein/components/ImageViewer.vue";
import GoodImageView from "../purchasein/components/GoodViewer.vue";
import OrderSign from "../../components/common/OrderSign.vue";
import { handleException } from "../../common/ErrorCodeHandle";
var PurBackDetail = (function (_super) {
    __extends(PurBackDetail, _super);
    function PurBackDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {};
        _this.tableData = [];
        _this.tableHeight = 0;
        _this.ePurInStatus = EPurInStatus;
        _this.imageOpen = false;
        _this.goodImageOpen = false;
        _this.imageArr = [];
        _this.goodImageArr = [];
        _this.orderDetailIds = [];
        _this.supplierGoodsTypeList = [];
        _this.goodsFormData = {
            goods_type_id: undefined,
            keyword: '',
        };
        return _this;
    }
    PurBackDetail.prototype.created = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.$el && _this.$el.parentElement) {
                _this.tableHeight = _this.$el.parentElement.clientHeight - 150;
            }
        }, 300);
        this.service = PurBackService.getInstance();
        this.commonService = CommonService.getInstance();
        GlobalVue.$on('ro_sign:ok', this.handleSignSuccess);
    };
    PurBackDetail.prototype.mounted = function () {
        this.getDetail();
        this.getGoodsTypeList();
    };
    PurBackDetail.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    PurBackDetail.prototype.search = function () {
        this.getDetail();
    };
    PurBackDetail.prototype.getGoodsTypeList = function () {
        var _this = this;
        this.commonService.getSupplierGoodsTypeList().then(function (res) {
            if (res.data.success) {
                _this.supplierGoodsTypeList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    PurBackDetail.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.rowId,
            goods_type_id: this.goodsFormData.goods_type_id,
            keyword: this.goodsFormData.keyword,
        };
        this.service.getDetail(params).then(function (res) {
            if (res.data.success) {
                _this.formData = res.data.data;
                _this.tableData = res.data.data.items;
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
            loadingInstance.close();
        }, function (err) {
            _this.$message.error(err.message || err.msg);
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    PurBackDetail.prototype.getSummaries = function (param) {
        var sums = [];
        var showSum = ["order_detail_inamount", "order_detail_oamount", "total_price"];
        sums = summaries(param, showSum);
        sums[0] = '单据合计';
        return sums;
    };
    PurBackDetail.prototype.toPurIn = function () {
        toDetail(EBillType.PurIn, this.formData.purchase_order_id);
    };
    PurBackDetail.prototype.toDeliver = function () {
        toDetail(EBillType.Deliver, this.formData.delivery_order_id);
    };
    PurBackDetail.prototype.mulConfirm = function () {
        var _this = this;
        this.$confirm("确认后将不可修改，是否继续？", "提示", {}).then(function (res) {
            var params = {
                order_id: _this.formData.order_id
            };
            var isForceSign = !!_this.formData.purchase_order_confirm;
            if (_this.formData.from_system) {
                var loadingInstance_1 = Loading.service({ fullscreen: true });
                var hisSign_1 = "";
                _this.service.latestSignImg(params).then(function (res) {
                    hisSign_1 = res.data.data.latest_sign_url;
                    var miniprogramQrcode = res.data.data.sign_url.url;
                    _this.$refs.order_sign_dialog.show({
                        type: 'rjo',
                        qrcode: miniprogramQrcode,
                        isForceSign: isForceSign,
                        hisSign: hisSign_1,
                        step: hisSign_1 ? 1 : 2,
                    });
                    loadingInstance_1.close();
                }).catch(function (err) {
                    loadingInstance_1.close();
                    _this.$message.error(err.message || err.msg);
                });
            }
            else {
                _this.afterSign(false, true, false);
            }
        }, function () {
        });
    };
    PurBackDetail.prototype.afterSign = function (check, skip_sign, use_latest_sign) {
        var _this = this;
        console.log(check, skip_sign, use_latest_sign);
        if (check) {
            this.service.getSignStatus({ order_ids: this.formData.order_id })
                .then(function (res) {
                var data = res.data;
                if (data.success && data.data.sign_status) {
                    _this.handleSignSuccess();
                }
                else {
                    _this.$message.warning('未获取签字信息，请重新扫码签字');
                }
            }, function (err) { });
        }
        if (skip_sign || use_latest_sign) {
            var params = {
                order_ids: this.formData.order_id
            };
            var loadingInstance_2 = Loading.service({ fullscreen: true });
            this.service.audit(params).then(function (res) {
                _this.handleSignSuccess(false);
                loadingInstance_2.close();
                if (res.data.code === 55) {
                    var instance = _this.$dialog(ArtMsglist, {
                        data: {
                            msgData: res.data.data,
                        },
                    }, {
                        title: '提示',
                        width: 450,
                        height: 350,
                    }).instance;
                    return;
                }
                if (res.data.code === 8) {
                    handleException(_this, res.data, _this.formData);
                    return;
                }
                if (res.data.code == 69) {
                    var _a = res.data, code = _a.code, data = _a.data;
                    var miniprogramQrcode = data.msg_data.url;
                    _this.$refs.order_sign_dialog.show({ type: 'rjo', qrcode: miniprogramQrcode });
                    return;
                }
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                    _this.getDetail();
                }
                _this.$message.success(res.data.msg || "操作成功");
                GlobalVue.$emit("closeTab", _this);
                if (_this.opener && _this.opener.getList) {
                    _this.opener.getList();
                }
                window._czc.push(["_trackEvent", '客户退货确认', '客户退货确认']);
            }, function (err) {
                _this.handleSignSuccess(false);
                _this.$message.error(err.message || err.msg);
            });
        }
    };
    PurBackDetail.prototype.closeimg = function (type) {
        this.imageOpen = type;
        this.goodImageOpen = type;
    };
    PurBackDetail.prototype.watchImg = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.orderImgById({ order_id: this.rowId }).then(function (res) {
            _this.imageArr = Array.isArray(res.data.data) ? res.data.data : [];
            loadingInstance.close();
            _this.imageOpen = true;
            _this.goodImageOpen = false;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    PurBackDetail.prototype.LookImage = function (orderDetailIds) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.orderDetailImg({ order_detail_ids: orderDetailIds }).then(function (res) {
            _this.goodImageArr = Array.isArray(res.data.data) ? res.data.data : [];
            loadingInstance.close();
            _this.goodImageOpen = true;
            _this.imageOpen = false;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    PurBackDetail.prototype.handleSignSuccess = function (alter) {
        if (alter === void 0) { alter = true; }
        if (alter) {
            this.getDetail();
        }
        this.$refs.order_sign_dialog.close();
    };
    PurBackDetail = __decorate([
        auth(nameDict["退货单"]),
        Component({
            computed: __assign({}, mapGetters({
                serviceData: 'serviceData',
                serviceDataList: 'serviceDataList'
            })),
            components: {
                'image-view': ImageView,
                'good-image-view': GoodImageView,
                'order-sign': OrderSign,
            },
        })
    ], PurBackDetail);
    return PurBackDetail;
}(Vue));
export default PurBackDetail;
